import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    border: theme.palette.lightOutlineGrey.main,
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.caption.fontSize,
    padding: 10,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    border: theme.palette.lightOutlineGrey.main,
  },
}));
